import { ICollaboration } from '@descomplica/microfrontend-core';
import { inject, injectable } from 'tsyringe';

import type {
  Event,
  EventTracker,
} from '../interfaces/event-tracker.interface';

@injectable()
export class TrackEventCollaboration implements ICollaboration<Event, void> {
  constructor(
    @inject('EventTracker')
    private readonly eventTracker: EventTracker,
  ) {}

  run(event: Event): void {
    this.eventTracker.trackEvent(event);
  }
}
